import types from '../mutation-types';
import AccountApiSettingApi from '../../api/accountChatSetting';
import AnalyticsHelper from '../../helper/AnalyticsHelper';
import { ACCOUNT_CHAT_SETTING_EVENTS } from '../../helper/AnalyticsHelper/events';

const CHAT_CONFIG_STORAGE_KEY = 'chat_config';

const state = {
  config: JSON.parse(localStorage.getItem(CHAT_CONFIG_STORAGE_KEY)) || {
    enable_emoticon: true,
    enable_voice: true,
    allowed_file_types: [],
  },
  uiFlags: {
    isFetching: false,
    isUpdating: false,
  },
  SET_FETCHING(_state, status) {
    _state.uiFlags.isFetching = status;
  },
  SET_UPDATING(_state, status) {
    _state.uiFlags.isUpdating = status;
  },
};

const mutations = {
  SET_CONFIG(_state, config) {
    _state.config = config;
    localStorage.setItem(CHAT_CONFIG_STORAGE_KEY, JSON.stringify(config));
  },
  SET_FETCHING(_state, status) {
    _state.uiFlags.isFetching = status;
  },
  SET_UPDATING(_state, status) {
    _state.uiFlags.isUpdating = status;
  },
};

const actions = {
  async fetch({ commit }) {
    commit(types.SET_FETCHING, true);
    try {
      const response = await AccountApiSettingApi.get();
      commit(types.SET_CONFIG, response.data);
    } catch (error) {
      throw new Error('Failed to fetch chat config: ' + error.message);
    } finally {
      commit(types.SET_FETCHING, false);
    }
  },

  async update({ commit }, config) {
    commit(types.SET_UPDATING, true);
    try {
      const response = await AccountApiSettingApi.update({
        account_chat_setting: config,
      });
      AnalyticsHelper.track(ACCOUNT_CHAT_SETTING_EVENTS.UPDATE);
      commit(types.SET_CONFIG, response.data);
    } catch (error) {
      throw new Error('Failed to fetch chat config: ' + error.message);
    } finally {
      commit(types.SET_UPDATING, false);
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
